import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import history from 'services/history';
import { useSurgerie } from '../../hooks/useSurgerie';

type SurgerieClosedMenuProps = {
  anchorEl: HTMLButtonElement | null;
};

const SurgerieClosedMenu: React.FC<SurgerieClosedMenuProps> = ({ anchorEl }) => {
  const { selectedSurgerie, setAnchorEl, setSelectedSurgerie } = useSurgerie();

  function handleClose() {
    setAnchorEl(null);
  }

  function handleCloseAndClear() {
    handleClose();
    setSelectedSurgerie(null);
  }

  function handlePrint() {
    window.open(`/surgeries/${selectedSurgerie?.status}/${selectedSurgerie?.id_int}/print`, '_blank');
    handleCloseAndClear();
  }

  function handleOpen() {
    history.push(`/surgeries/${selectedSurgerie?.id_int}`);
  }

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseAndClear}>
      <MenuItem onClick={handleOpen}>Abrir orçamento</MenuItem>
      <MenuItem onClick={handlePrint}>Imprimir orçamento</MenuItem>
    </Menu>
  );
};

export default SurgerieClosedMenu;
